import { Option } from './GroupMultiSelect.types';

export function optionsToMainLabel(selected: Option[], placeholder?: string): string | undefined {
  const labels = selected.map((o) => o.label);
  return labels.length ? labels.join(', ') : placeholder;
}
